import { api } from '@/lib/api';
import { createFileRoute } from '@tanstack/react-router';
import LocaisHd from './-component';

export const Route = createFileRoute(
  '/__authenticated/comercial/produto/clientes/hibridos/$id/locais-hd',
)({
  context: ({ params }) => ({
    locaisHdQueryOptions: api.queryOptions(
      'get',
      '/clientes/hibridos/{id}/locais-hd',
      {
        params: { path: { id: params.id } },
      },
      { staleTime: 1000 * 60 },
    ),
  }),
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(context.locaisHdQueryOptions);
  },
  component: LocaisHd,
});
